import { Enums } from '@bode-canada/core';
import ServerlessApiService from '../ServerlessApiService';

export default class DashboardApiService {
  static BASE_URL = `/${Enums.DashboardApiPathEnum.DASHBOARD}/${Enums.ServerlessApiPathEnum.V1}`;

  static getDashboardByListingId(id) {
    return ServerlessApiService.get(`${this.BASE_URL}/${id}`);
  }

  static createListingViewsByListingId(id) {
    return ServerlessApiService.post(`${this.BASE_URL}/listing-views/${id}`);
  }

  static getListingViewsByListingId(id) {
    return ServerlessApiService.get(`${this.BASE_URL}/listing-views/${id}`);
  }
}
